<template>
  <div class="row">
    <user-menu></user-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
      <form @submit.prevent="submit" autocomplete="off">
        <div class="dammy" style="width:0;height:0;border:none;position:absolute;bottom:0;z-index:-1;">
            <input type="text" style="border:none">
            <input type="password" style="border:none">
        </div>
        <div class="form-group">
          <label for="userName">氏名<span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="userName" placeholder="例) 山田 太郎" v-model="postData.userName" autocomplete="userName" required>
        </div>
        <div v-show="!postData.deletedAt" class="notRetiree">
          <div class="form-group">
            <label for="mail">メールアドレス<span class="text-danger">*</span> <span class="text-danger" v-if="invalidMail">既に登録されています</span></label>
            <div class="input-group col-md-6 p-0">
              <input type="mail" class="form-control" :class="{'border-danger': invalidMail}" id="mail" placeholder="例) atmanage" autocomplete="nope" v-model="postData.mailInput" @change="inputMail" required>
              <span class="input-group-append" style="font-size: 1.2rem; padding: 5px;">@{{ postData.domain }}</span>          
            </div>
          </div>
          <div class="form-group">
            <label for="password">パスワード</label><span v-if="!edit" class="text-danger">*</span> <span class="text-danger" v-if="invalidPassword">パスワードは6文字以上20文字以下で入力ください</span></label>
            <input v-if="edit" type="password" class="form-control" id="password" placeholder="任意。変更する場合はパスワードを入力ください" autocomplete="nope" v-model="postData.password" :class="{'border-danger': invalidPassword}" maxlength='20'>
            <input v-else type="password" class="form-control" id="password" placeholder="パスワードを入力ください" autocomplete="nope" v-model="postData.password" :class="{'border-danger': invalidPassword}" maxlength='20' required>
          </div>
          <div class="form-group">
            <label for="unit">部署</label>
            <div>
              <label v-for="current in departmentList" :key="current.id" class="mr-1">
                <input type="checkbox" name="department" v-model="postData.departmentIdList" :value="current.id">
                {{current.departmentName}}
              </label>
            </div>
          </div>
          <div class="form-group">
                <label>権限</label>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" name="role" v-model="selectedRoleDefault" value="ROLE_USER" disabled='disabled' checked='checked'>
                        <span class="checkbox-material"><span class="check"></span></span></input>
                        一般権限
                    </label>
                </div>
                <div class="checkbox" v-if="hasAnyRole('ROLE_ADMIN')">
                    <label>
                        <input type="checkbox" name="role" id="roleAdminCheck" v-model="selectedRoleFull" value="ROLE_ADMIN" :disabled="postData.userId == loginUser.userId">
                        <span class="checkbox-material"><span class="check"></span></span></input>
                        フル権限
                    </label>
                </div>
                <div id="roleOption" v-if="advanced">
                    <table class="table table-bordered table-responsive">
                        <thead class="thead-light">
                          <tr>
                              <th>休暇申請管理</th>
                              <th>交通費管理</th>
                              <th>勤怠管理</th>
                              <th>ユーザ管理</th>
                              <th>マネジメント権限</th>
                          </tr>
                        </thead>
                        <tbody>
                        <tr class="text-center">
                            <td>
                                <select id="roleYukyu" class="custom-select" name="role" v-model="selectedRoleYukyu">
                                    <option value="" selected="true">なし</option>
                                    <option value="ROLE_YUKYU_READ">参照</option>
                                    <option value="ROLE_YUKYU_ADMIN">フル権限</option>
                                </select>
                            </td>
                            <td>
                                <select id="roleKotsuhi" class="custom-select" name="role" v-model="selectedRoleKotsuhi">
                                    <option value="" selected="true">なし</option>
                                    <option value="ROLE_KOTSUHI_READ">参照</option>
                                    <option value="ROLE_KOTSUHI_ADMIN">フル権限</option>
                                </select>
                            </td>
                            <td>
                                <select id="roleWork" class="custom-select" name="role" v-model="selectedRoleWork">
                                    <option value="" selected="true">なし</option>
                                    <option value="ROLE_WORK_READ">参照</option>
                                    <option value="ROLE_WORK_ADMIN">フル権限</option>
                                </select>
                            </td>
                            <td>
                                <select id="roleUser" class="custom-select" name="role" v-model="selectedRoleUser">
                                    <option value="" selected="true">なし</option>
                                    <option value="ROLE_USER_READ">参照</option>
                                    <option value="ROLE_USER_ADMIN">フル権限</option>
                                </select>
                            </td>
                            <td>
                                <select id="roleManage" class="custom-select" name="role" v-model="selectedRoleManage">
                                    <option value="" selected="true">なし</option>
                                    <option value="ROLE_MANAGE">マネジメント権限</option>
                                </select>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="togglebutton" id="roleAdvance">
                    <label>
                        <input id="roleOptionToggle" type="checkbox" v-model="advanced"/><span class="toggle"></span>高度な設定
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label>シフト</label>
                <div>
                    <select class="custom-select" name="defaultWorkShiftId" v-model="postData.defaultWorkShiftId">
                        <option :value="null">なし</option>
                        <option v-for="shift in workShiftList" :value="shift.id" :key="shift.id">
                          {{shift.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <label>労働時間単位</label>
                <div>
                    <select class="custom-select" name="defaultWorkTimeInterval" v-model="postData.defaultWorkTimeInterval">
                        <option selected="true">なし</option>
                        <option value="0">0</option>
                        <option value="15">15</option>
                        <option value="30">30</option>
                        <option value="60">60</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <label>入社日</label>
                <div>
                  <el-date-picker v-model="postData.hireDate" type="date" placeholder="入社日を入力してください"></el-date-picker>
                </div>
            </div>
            <div class="form-group">
                <label>研修期間（月数）<span class="text-danger">*</span></label>
                <input type="number" class="form-control" placeholder="デフォルトは0で登録されます" v-model="postData.trainingMonth" required/>
            </div>
            <div class="form-group">
                <label>緊急連絡先</label>
                <textarea class="form-control" placeholder="255文字まで自由記入" v-model="postData.emergencyContact" maxlength='255' rows="4"></textarea>
            </div>
            <div class="form-group">
                <label>
                  勤怠ファイル名
                  <button type="button" class="btn badge badge-info" data-toggle="modal" data-target="#help-modal">
                    説明
                  </button>
                </label>
                <!-- 説明モーダル -->
                <div class="modal fade" id="help-modal" tabindex="-1" role="dialog" aria-labelledby="help-modal-label" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="help-modal-label">勤怠ファイル名の説明</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body p-3">
                                <p>空の場合、デフォルトのファイル名が使用されます。</p>
                                <p>{}は任意です。{}内は置換されます。</p>
                                <p>{}の使える種類は以下になります。</p>
                                <li>{year}: 該当年で置換されます。</li>
                                <li>{month}: 該当月で置換されます。</li>
                                <li>{name}: 該当ユーザ氏名で置換されます。</li>
                            </div>
                        </div>
                    </div>
                </div>
                <input type="text" class="form-control" placeholder="例) {year}{month}_{name}_勤務表" v-model="postData.outputWorkFilename" maxlength='50'></input>
          </div>
          <div>
            <label>生年月日</label>
            <div class="form-group form-inline">
              <select name="birthday-yaer" class="form-control col-md-1" v-model="selectedYear">
                <option v-for="year in yearList" :key="year" :value="year">{{year}}</option>
              </select>
              <label for="birthday-year" class="birthday-label">年</label>
              <select name="birthday-month" class="form-control col-md-1" v-model="selectedMonth">
                <option v-for="(month, index) in 12" :key="index" :value="index">{{month}}</option>
              </select>
              <label for="birthday-month" class="birthday-label">月</label>
              <select name="birthday-date" class="form-control col-md-1" v-model="selectedDate">
                <option v-for="date in endOfMonth" :key="date" :value="date">{{date}}</option>
              </select>
              <label for="birthday-date" class="birthday-label">日</label>
            </div>
          </div>
        </div>

        <!-- 退職者 -->
        <div v-if="postData.deletedAt">
          <div class="form-group">
              <label>退職日</label> <span class="text-danger"> *設定無しの場合、退職扱いではなくなります</span>
              <div>
                  <el-date-picker v-model="retireeDate" type="date"></el-date-picker>
              </div>
          </div>
        </div>

        <button type="button" class="btn btn-secondary m-2" @click="goUserList">戻る</button>
        <input v-if="edit" type="submit" class="btn btn-primary" value="編集"/>
        <input v-else type="submit" class="btn btn-primary" value="登録"/>
      </form>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import UserAPI from '../../../api/user-api'
import DepartmentAPI from '../../../api/department-api'
import ShiftAPI from '../../../api/shift-api'
import CommonAPI from '../../../api/common-api'
import UserMenu from './UserMenu.vue'
import moment from 'moment'

export default {
  name: "new-edit-user",
  components: {
    UserMenu
  },
  data() {
    return {
      edit: false,
      // バリデーション
      invalidMail: false,
      invalidPassword: false,
      // 高度な権限設定
      advanced: false,
      selectedRoleDefault: 'ROLE_USER',
      selectedRoleYukyu: null,
      selectedRoleKotsuhi: null,
      selectedRoleWork: null,
      selectedRoleUser: null,
      selectedRoleFull: null,
      selectedYear: null,
      selectedMonth: null,
      selectedDate: null,
      yearList: [],
      endOfMonth: null,
      workShiftList: [],
      departmentList: [],
      loginUser: {
        role: 'ROLE_USER'
      },
      postData: {
        userId: null,
        unit: '',
        userName: '',
        mailInput: '',
        domain: '',
        role: 'ROLE_USER',
        password: null,
        invalid: false,
        departmentIdList: [],
        defaultWorkShiftId: null,
        trainingMonth: 0,
        outputWorkFilename: ''
      },
      retireeDate: null
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
      this.postData.domain = this.loginUser.domain
    },
    // 高度な設定
    'advanced': function (val) {
      if (val) {
        this.selectedRoleFull = null
      } else {
        this.selectedRoleYukyu = null
        this.selectedRoleKotsuhi = null
        this.selectedRoleWork =  null
        this.selectedRoleUser = null
        this.selectedRoleManage = null
      }
    },
    'selectedRoleFull': function (val) {
      if (val) {
        this.advanced = false
        this.selectedRoleFull = 'ROLE_ADMIN'
      }
    },
    // 生年月日
    'selectedYear': function (to, from) {
      if (this.selectedYear && this.selectedMonth){
        this.endOfMonth = moment().year(this.selectedYear).month(this.selectedMonth).date(1).endOf('month').date()
      }
    },
    'selectedMonth': function (to, from) {
      if (this.selectedYear && this.selectedMonth){
        this.endOfMonth = moment().year(this.selectedYear).month(this.selectedMonth).date(1).endOf('month').date()
      }
    },
  },
  mounted () {
    this.setYearList()
    this.getWorkShiftList()
    this.init()
    this.getDepartmentList()
    this.$root.$refs.loading.$data.show = false
  },
  methods: {
    // 新規 or 更新の判定
    init () {
      const id = this.$route.params.id
      if (id) {
        this.edit = true
        this.getUser(id)
      }
    },
    // メール入力時
    inputMail () {
      // 起動時のエラー表示を防ぐ
      if (this.$route.params.id && this.postData.userId == null) {
        return false
      }

      this.postData.mailInput = this.postData.mailInput.split('@')[0]
      this.postData.mail = this.postData.mailInput + '@' + this.postData.domain
      this.$forceUpdate();

      const body = {
        userId: this.postData.userId,
        mail: this.postData.mail
      }
      // 重複チェック
      UserAPI.isExists(body)
          .then(res => {
            this.invalidMail = res.isExists;
          })
          .catch(err => {
            console.error(err)
          })
    },
    // ユーザ取得
    getUser (id) {
      this.$root.$refs.loading.$data.show = true
      UserAPI.getUser(id)
          .then(res => {
            this.postData = res
            // 権限の画面設定
            this.selectedRoleFull = this.hasAnyRoleByPostData('ROLE_ADMIN') ? 'ROLE_ADMIN' : null
            this.selectedRoleYukyu = this.hasAnyRoleByPostData('ROLE_YUKYU_ADMIN') ? 'ROLE_YUKYU_ADMIN' : null
            if (!this.selectedRoleYukyu) {
              this.selectedRoleYukyu = this.hasAnyRoleByPostData('ROLE_YUKYU_READ') ? 'ROLE_YUKYU_READ' : null
            }
            this.selectedRoleKotsuhi = this.hasAnyRoleByPostData('ROLE_KOTSUHI_ADMIN') ? 'ROLE_KOTSUHI_ADMIN' : null
            if (!this.selectedRoleKotsuhi) {
              this.selectedRoleKotsuhi = this.hasAnyRoleByPostData('ROLE_KOTSUHI_READ') ? 'ROLE_KOTSUHI_READ' : null
            }
            this.selectedRoleWork = this.hasAnyRoleByPostData('ROLE_WORK_ADMIN') ? 'ROLE_WORK_ADMIN' : null
            if (!this.selectedRoleWork) {
              this.selectedRoleWork = this.hasAnyRoleByPostData('ROLE_WORK_READ') ? 'ROLE_WORK_READ' : null
            } 
            this.selectedRoleUser = this.hasAnyRoleByPostData('ROLE_USER_ADMIN') ? 'ROLE_USER_ADMIN' : null
            if (!this.selectedRoleUser) {
              this.selectedRoleUser = this.hasAnyRoleByPostData('ROLE_USER_READ') ? 'ROLE_USER_READ' : null
            }
            this.selectedRoleManage = this.hasAnyRoleByPostData('ROLE_MANAGE') ? 'ROLE_MANAGE' : null
            if (this.selectedRoleYukyu || this.selectedRoleKotsuhi || this.selectedRoleWork || this.selectedRoleUser || this.selectedRoleManage) {
              this.advanced = true
            }
            if(this.postData.birthday){
              this.selectedYear = moment(this.postData.birthday).year()
              this.selectedMonth = moment(this.postData.birthday).month()
              this.selectedDate = moment(this.postData.birthday).date()
            }
            if(this.postData.deletedAt){
              this.retireeDate = this.postData.deletedAt
            }
            this.postData.mailInput = this.postData.mail.split('@')[0]
            this.$root.$refs.loading.$data.show = false
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // シフト一覧取得
    getWorkShiftList () {
      ShiftAPI.getShiftList()
          .then(res => {
            this.workShiftList = res
          })
          .catch(err => {
            console.error(err)
          })
    },
    // 部署一覧取得
    getDepartmentList() {
      this.$root.$refs.loading.$data.show = true
      DepartmentAPI.getList()
            .then(res => {
              this.departmentList = res ? res : []
              this.$nextTick(function() {
                this.$root.$refs.loading.$data.show = false
              })
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
    },
    // 年一覧設定
    setYearList() {
      const since = 1900
      const until = moment().year()
      const between = until - since;
      this.yearList = []
      for(let i = 0; i <= between; i++){
        this.yearList.push(since + i)
      }
      this.yearList.reverse()
    },
    // 生年月日設定
    setBirthday() {
      if(this.selectedYear && this.selectedMonth && this.selectedDate) {
        this.postData.birthday = moment().year(this.selectedYear).month(this.selectedMonth).date(this.selectedDate).format("YYYY-MM-DD")
      }
    },
    submit () {
      // バリデーション
      let invalidCount = 0
      // パスワードの長さチェック。入力がない場合は変更なしとみなす
      if (this.edit) {
        if (this.postData.password != null && (this.postData.password.length < 6 || this.postData.password.length >= 20)) {
          this.invalidPassword =  true
          document.getElementById("mail").scrollIntoView(true)
          invalidCount += 1
        }
      } else {
        if (this.postData.password.length < 6 || this.postData.password.length >= 20) {
          this.invalidPassword =  true
          document.getElementById("mail").scrollIntoView(true)
          invalidCount += 1
        }
      }
      // メール重複チェック
      if (this.invalidMail) {
        document.getElementById("userName").scrollIntoView(true)
        invalidCount += 1
      }
      if (invalidCount > 0) {
        return false
      }
      // 生年月日
      this.setBirthday()

      this.$root.$refs.loading.$data.show = true
      // 権限の設定
      let roleList = [this.selectedRoleDefault]
      if (this.selectedRoleFull){
        roleList.push(this.selectedRoleFull)
      } else {
        if (this.selectedRoleYukyu) {
            roleList.push(this.selectedRoleYukyu)
        }
        if (this.selectedRoleKotsuhi) {
            roleList.push(this.selectedRoleKotsuhi)
        }
        if (this.selectedRoleWork) {
            roleList.push(this.selectedRoleWork)
        }
        if (this.selectedRoleUser) {
            roleList.push(this.selectedRoleUser)
        }
        if (this.selectedRoleManage) {
            roleList.push(this.selectedRoleManage)
        }
      }
      this.postData.role = roleList.join()

      // 入社日のフォーマット
      if (this.postData.hireDate) {
        this.postData.hireDate = moment(this.postData.hireDate).format('YYYY-MM-DD')
      }

      if (this.edit){
        // 編集
        this.postData.deletedAt = this.retireeDate ? moment(this.retireeDate).format("YYYY-MM-DD HH:mm") : null
        UserAPI.editUser(this.postData)
            .then(res => {
              this.goUserList()
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      } else {
        // 新規登録
        UserAPI.createUser(this.postData)
            .then(res => {
              this.goUserList()
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      }
    },
    // ユーザ管理トップ画面へ
    goUserList () {
        this.$router.push('/admin/user/top')
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    hasAnyRoleByPostData: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.postData.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    }
  },
  computed: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/user/UserNewEdit.vue